import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M6.859 3.958h4.166l4.584 4.584v5.833c0 .92-.746 1.667-1.667 1.667H6.859c-.92 0-1.667-.747-1.667-1.667v-8.75c0-.92.746-1.667 1.667-1.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M9.142 11.511a1.581 1.581 0 0 0 1.322.623c.81 0 1.466-.493 1.466-1.1 0-.608-.654-1.1-1.464-1.1-.809 0-1.466-.493-1.466-1.1 0-.609.657-1.1 1.466-1.1a1.58 1.58 0 0 1 1.322.621m-1.322 3.778v.734m0-5.867v.733" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);